import React, { useMemo, useCallback } from 'react'
import PropTypes from 'prop-types'
import { artifacts } from '../../../api/integrations'
import SydSelect from '../../commonDesign/SydSelect'
import { useFormattingContext } from '../FormattingProvider/FormattingContext'
import { useArtifact } from './ArtifactProvider'

function formatReportName (code) {
  const path = code?.split('?')[0] || code
  const type = path?.split('/').pop() || path
  return type
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2')
    .replace(/\bAnd\b/g, 'and')
}

function ArtifactSelector ({
  connectionId: connectionIdProp,
  label = 'Select Report',
  size,
  placeholder = 'Choose a report...'
}) {
  const { selectArtifact, selectedArtifactId, connectionId: providerConnectionId } = useArtifact()
  const { formatter } = useFormattingContext()

  const resolvedConnectionId = connectionIdProp ?? providerConnectionId
  const { data, isLoading } = artifacts.useListArtifactsPicklist(resolvedConnectionId)

  const options = useMemo(() => {
    return (data?.artifacts ?? []).map(a => {
      const name = formatReportName(a.code)
      let dateRange = ''
      if (a.startDate && a.endDate) {
        const sameYear = a.startDate.slice(0, 4) === a.endDate.slice(0, 4)
        const start = formatter(a.startDate, sameYear ? '@MMM D' : '@MMM D, YYYY')
        const end = formatter(a.endDate, '@MMM D, YYYY')
        dateRange = `${start} \u2013 ${end}`
      }
      return {
        value: a.artifactId,
        label: dateRange ? `${name} (${dateRange})` : name,
        description: a.connectionName
      }
    })
  }, [data, formatter])

  const handleChange = useCallback((e) => {
    const value = e?.target?.value ?? e
    selectArtifact(value || null)
  }, [selectArtifact])

  return (
    <SydSelect
      label={label}
      size={size}
      value={selectedArtifactId ?? ''}
      options={options}
      onChange={handleChange}
      placeholder={isLoading ? 'Loading...' : placeholder}
      disabled={isLoading || options.length === 0}
    />
  )
}

ArtifactSelector.propTypes = {
  connectionId: PropTypes.number,
  label: PropTypes.string,
  size: PropTypes.oneOf(['xs', 'sm', 'lg']),
  placeholder: PropTypes.string
}

export default ArtifactSelector
